import { searchBySearchIdSelector, makeNullSafeDomainGetter } from './common';

export const searchByIdSelector = makeNullSafeDomainGetter(searchBySearchIdSelector, 'searchBySearchId');
